import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FAQRow from 'Components/Rows/FAQRow';
import FAQContent from 'Components/FAQContent';
import HeaderSimplePage from 'Components/HeaderMobile/SimplePage';
import { isWebviewRenderType } from 'Utils/webviewMode';
import { getHelpMenu, getHelpMenuDetails } from 'Store/actions';

const FrequentlyAskedQuestions = ({
  faqType,
  helpMenu,
  helpMenuDetails,
  getHelpMenu,
  getHelpMenuDetails,
}) => {
  // null: henüz mount olmadı — webview kontrolü sadece client'ta yapılabiliyor.
  const [isWebview, setIsWebview] = useState(null);


  useEffect(() => {
    if (faqType) {
      getHelpMenuDetails(faqType);
    } else {
      getHelpMenu();
    }
    
    setIsWebview(isWebviewRenderType());
  }, [faqType]);

  const hasHeader = isWebview === false;


  if (faqType) {
    return <FAQContent hasHeader={ hasHeader } data={ helpMenuDetails?.questions } />;
  }

  return (
    <>
      { hasHeader && <HeaderSimplePage color="green" title="Yardım Konuları" /> }
      <div className="page page--faq">
        <div className="faq-container">
          { helpMenu?.map((menu, index) => (
            <FAQRow key={ index } subject={ menu.displayName } path={ menu.url } />
          )) }
        </div>
      </div>
    </>
  );
};

FrequentlyAskedQuestions.propTypes = {
  helpMenu: PropTypes.array,
  helpMenuDetails: PropTypes.array,
  faqType: PropTypes.string,
  getHelpMenu: PropTypes.func,
  getHelpMenuDetails: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => ({
  helpMenu: state.cms.helpMenu.menu,
  helpMenuDetails: state.cms.helpMenu.details[ownProps.faqType],
});

export default connect(mapStateToProps, {
  getHelpMenu,
  getHelpMenuDetails,
})(FrequentlyAskedQuestions);
